import React from "react";

import HeroBanner from "./HeroBanner";
import Condition from "./Condition";
import AppelAction from "../../components/AppelAction";
import SEOHead from "../../components/SEOHead";
import { usePageSEO } from "../../utils/seoUtils";

const Conditions = () => {
  const seoData = usePageSEO('/cgu');

  return (
    <>
      <SEOHead {...seoData} />
      <HeroBanner />
      <Condition />
      <AppelAction className="section-border-top" />
    </>
  );
};

export default Conditions;
